import React from 'react';
import './LoadingDefault.scss';
import LoadingOrError from '../LoadingOrError/LoadingOrError';
import LoginDefaultSpinner from '../LoginDefaultSpinner/LoginDefaultSpinner';
import { i18nService } from 'src/services/i18n.service';

/**
 * The default loading component
 */
const LoadingDefault: React.FC = () => {
  return (
    <LoadingOrError loadingMessage={i18nService.translate('loadingMessage2')} loading={true} />
  );
};

export default LoadingDefault;
